import React from 'react';
import zovcurLogo from '../../assets/logo/logo.jpg';

const ZovcurInvoiceHeader = ({ company, invoiceDetails, invoiceNumber, showBadge = true }) => (
  <div className="relative overflow-hidden rounded-t-xl">
    <div className="bg-gradient-to-r from-[#1a365d] via-[#1e4976] to-[#0d9488] px-5 py-4 text-white">
      <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4">
        <div className="flex items-center gap-4 flex-1 min-w-0">
          <div className="shrink-0 bg-white rounded-lg p-1.5 shadow-md">
            <img
              src={zovcurLogo}
              alt="Zovcur Pharma"
            className="h-10 sm:h-14 w-auto object-contain"
            />
          </div>
          <div className="min-w-0">
            <h2 className="text-xl sm:text-2xl font-bold tracking-wide">
              {company?.name || 'Zovcur Pharma'}
            </h2>
            <p className="text-xs sm:text-sm text-teal-100 mt-1 leading-relaxed max-w-xl">
              {company?.address}
            </p>
            <div className="flex flex-wrap gap-x-4 gap-y-1 mt-2 text-xs text-teal-50">
              <span>
                DL No: <strong className="text-white">{company?.dlNo || '—'}</strong>
              </span>
              <span>
                Phone: <strong className="text-white">{company?.phone}</strong>
              </span>
            </div>
          </div>
        </div>
        {showBadge && (
          <div className="shrink-0 text-center">
            <div className="bg-amber-500 text-white font-bold text-sm px-4 py-2 rounded-lg shadow-lg uppercase tracking-wider">
              Tax Invoice
            </div>
            <p className="text-xs mt-2 text-teal-100">
              Bill No: <span className="font-bold text-white text-sm">
                {invoiceNumber || invoiceDetails?.billNo || '—'}
              </span>
            </p>
          </div>
        )}
      </div>
    </div>
    <div className="h-1 bg-gradient-to-r from-teal-400 via-amber-400 to-rose-400" />
  </div>
);

export default ZovcurInvoiceHeader;
export { zovcurLogo };
